import {SCANNER_RESPONSE_CODES, SCANNER_COMMANDS, SCANNER_DEFAULT_VALUES} from "../../../../constants";
import SCANNER from '../../../../maya_api/scanner';
import {b64toBlob, getCardData, S} from "../../../../helpers";
import _ from 'lodash'

const $$_START_SCAN = '$$_START_SCAN';
const $$_DISCONNECT = '$$_DISCONNECT';
const $$_DISCONNECT_PROCESSING = '$$_DISCONNECT_PROCESSING';
const $$_RESET_RESULT = '$$_RESET_RESULT';
const $$_CHANGE_SCANNER_SERVER_STATUS = '$$_CHANGE_SCANNER_SERVER_STATUS';

const COMMANDS = {
  [SCANNER_COMMANDS.CHECK_CONNECTED]: SCANNER.checkConnected,
  [SCANNER_COMMANDS.GET_DEVICES]: SCANNER.getDevices,
  [SCANNER_COMMANDS.DO_SCAN]: SCANNER.doScan,
  [SCANNER_COMMANDS.DO_CONNECT]: SCANNER.doConnect,
  [SCANNER_COMMANDS.DO_DISCONNECT]: SCANNER.doDisconnect
};

const RESPONSE_STATUSES = {
  RESP_ST_OK: 'RESP_ST_OK',
  RESP_ST_NOT_CONNECTED: 'RESP_ST_NOT_CONNECTED',
  RESP_ST_TIMEOUT: 'RESP_ST_TIMEOUT',
  RESP_ST_FAIL: 'RESP_ST_FAIL',
  RESP_ST_UNKNOWN: 'RESP_ST_UNKNOWN',
  RESP_ST_INVALID_ARG: 'RESP_ST_INVALID_ARG',
  RESP_ST_NO_DEVICES: 'RESP_ST_NO_DEVICES'
};

function startScan(type) {
  return async (dispatch, getStore) => {
    const inDisconnect = getStore().scanner.in_disconnect;
    if (inDisconnect) return console.log('Interrupted by disconnect');

    const daemonConnectionResult = await runCommand(SCANNER_COMMANDS.CHECK_CONNECTED);

    if (!(daemonConnectionResult && daemonConnectionResult.isConnected)) {
      const scannerConnectionResult = await connectToScanner();
      //if(!scannerConnectionResult) return
      if(!scannerConnectionResult) return dispatch(startScan(type));
    }

    const doScanResult = await runCommand(SCANNER_COMMANDS.DO_SCAN, {type: type, timeout: 5000});

    if (doScanResult && doScanResult.status === RESPONSE_STATUSES.RESP_ST_OK) {
      updateResult(dispatch, doScanResult);
      await sleep(1000);
    }

    return dispatch(startScan(type));
  }
}

async function connectToScanner() {
  let result = false;
  let getDevicesResult = await runCommand(SCANNER_COMMANDS.GET_DEVICES);

  if(getDevicesResult && getDevicesResult.arrDevices){
    const device = _.find(getDevicesResult.arrDevices, (device) => /ImageSafe/.test(device));
    if(!device) console.log('=== Device not found ===');

    if(device){
      const scannerConnectionResult = await runCommand(SCANNER_COMMANDS.DO_CONNECT, {devName: device})

      if(scannerConnectionResult && scannerConnectionResult.status
        && scannerConnectionResult.status === RESPONSE_STATUSES.RESP_ST_OK){
        result = true;
      }
    }
  }

  return result;
}

function updateResult(dispatch, doScanResult) {
  const account = doScanResult.magIncInfo.account;
  const amount = doScanResult.magIncInfo.amount;
  const track1 = doScanResult.magCardInfo.track1Data;
  const track2 = doScanResult.magCardInfo.track2Data;
  let cardData = {};

  if (track1 && track2) {
    cardData = getCardData(track1, track2) || {}
  }

  let imageFrontBlobUrl = '';
  let imageBackBlobUrl = '';

  if(/[A-Za-z0-9+/=]/.test(S(doScanResult.b64ImageFront))){
    imageFrontBlobUrl = URL.createObjectURL(b64toBlob(doScanResult.b64ImageFront, 'image/png'), 'image/png');
  }

  if(/[A-Za-z0-9+/=]/.test(S(doScanResult.b64ImageBack))){
    imageBackBlobUrl = URL.createObjectURL(b64toBlob(doScanResult.b64ImageBack, 'image/png'), 'image/png');
  }

  console.log('imageFrontBlobUrl', imageFrontBlobUrl);
  console.log('imageBackBlobUrl', imageBackBlobUrl);

  dispatch({
    type: $$_START_SCAN,
    payload: {
      imageFront: imageFrontBlobUrl,
      imageBack: imageBackBlobUrl,
      account: account,
      amount: amount,
      ...cardData
    }
  });
}

async function runCommand(command, data) {
  const result = await COMMANDS[command](data);
  console.log(`${command} =>`, result);
  return result;
}

function sleep(timeout) {
  return new Promise((resolve) => setTimeout(resolve, timeout))
}

function disconnect() {
  return async (dispatch, getStore) => {

    dispatch(disconnectProcessing(true));

    let resp = await COMMANDS[SCANNER_COMMANDS.DO_DISCONNECT]();
    console.log(`${SCANNER_COMMANDS.DO_DISCONNECT} =>`, resp);

    dispatch(disconnectProcessing(false));

    dispatch({
      type: $$_DISCONNECT,
    })
  }
}

function disconnectProcessing(value = false) {
  return {
    type: $$_DISCONNECT_PROCESSING,
    payload: value
  }
}

function resetScannerResult() {
  return {
    type: $$_RESET_RESULT,
    payload: ''
  }
}

function changeScannerServerStatus(status) {
  return {
    type: $$_CHANGE_SCANNER_SERVER_STATUS,
    payload: status
  }
}

export {
  startScan,
  resetScannerResult,
  disconnect,
  disconnectProcessing,
  changeScannerServerStatus
}


// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [$$_START_SCAN]: (state, action) => ({
    ...state,
    imageFront: action.payload.imageFront,
    imageBack: action.payload.imageBack,
    account: action.payload.account,
    amount: action.payload.amount,

    cardTrack1: action.payload.track1,
    cardTrack2: action.payload.track2,
    cardFormatCode: action.payload.cardFormatCode,
    cardAccountNumber: action.payload.cardAccountNumber,
    cardHolderName: action.payload.cardHolderName,
    cardExpirationData: action.payload.cardExpirationData,
    cardServiceCode: action.payload.cardServiceCode,
    cardDiscretionaryData: action.payload.cardDiscretionaryData,
  }),
  [$$_DISCONNECT]: (state) => initialState,
  [$$_DISCONNECT_PROCESSING]: (state, action) => ({
    ...state,
    in_disconnect: action.payload
  }),
  [$$_RESET_RESULT]: (state) => ({
    ...initialState,
    in_disconnect: state.in_disconnect
  }),
  [$$_CHANGE_SCANNER_SERVER_STATUS]: (state, action) => ({
    ...state,
    scanner_server_status: action.payload
  })
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  imageFront: '',
  imageBack: '',
  account: '',
  amount: '',
  cardTrack1: '',
  cardTrack2: '',
  cardFormatCode: '',
  cardAccountNumber: '',
  cardHolderName: '',
  cardExpirationData: '',
  cardServiceCode: '',
  cardDiscretionaryData: '',
  in_disconnect: false,
  scanner_server_status: true
};

export default function deviceScannerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/components/Devices/Scanner/modules/scanner.js